export const ACTOR_TYPES = [
  "pc",
  "npc",
  "companion",
  "community",
  "vehicle",
  "marker"
];

/* -------------------------------------------- */

export const PROPERTIES = [
  "activeEffect.deleted",
  "activeEffect.disabled",
  "actor.inCombat",
  "actor.itemCreated",
  "actor.itemDeleted",
  "actor.name",
  "actor.system.abilities.preparedSpells",
  "actor.system.basic.advancement.edge",
  "actor.system.basic.advancement.effort",
  "actor.system.basic.advancement.other",
  "actor.system.basic.advancement.skill",
  "actor.system.basic.advancement.stats",
  "actor.system.basic.descriptor",
  "actor.system.basic.effort",
  "actor.system.basic.focus",
  "actor.system.basic.tier",
  "actor.system.basic.type",
  "actor.system.basic.xp",
  "actor.system.combat.armor.costTotal",
  "actor.system.combat.armor.ratingTotal",
  "actor.system.combat.damageTrack.state",
  "actor.system.combat.damageTrack.applyImpaired",
  "actor.system.combat.damageTrack.applyDebilitated",
  "actor.system.combat.recoveries.roll",
  "actor.system.combat.recoveries.oneAction",
  "actor.system.combat.recoveries.oneHour",
  "actor.system.combat.recoveries.tenHours",
  "actor.system.combat.recoveries.tenMinutes",
  "actor.system.equipment.cypherLimit",
  "actor.system.pools.additional.value",
  "actor.system.pools.additional.max",
  "actor.system.pools.additional.edge",
  "actor.system.pools.intellect.value",
  "actor.system.pools.intellect.max",
  "actor.system.pools.intellect.edge",
  "actor.system.pools.might.value",
  "actor.system.pools.might.max",
  "actor.system.pools.might.edge",
  "actor.system.pools.speed.value",
  "actor.system.pools.speed.max",
  "actor.system.pools.speed.edge",
  "item.name",
  "item.system.basic.cost",
  "item.system.basic.damage",
  "item.system.basic.level",
  "item.system.basic.pool",
  "item.system.basic.quantity",
  "item.system.basic.skillRating",
  "item.system.basic.steps",
  "item.system.basic.type",
  "item.system.basic.totalModified",
  "item.system.weight",
  "token.disposition",
  "token.elevation",
  "token.name",
  "token.rotation",
  "token.sight.angle",
  "token.sight.attenuation",
  "token.sight.brightness",
  "token.sight.color",
  "token.sight.contrast",
  "token.sight.enabled",
  "token.sight.range",
  "token.sight.saturation",
  "token.sight.visionMode"
];

/* -------------------------------------------- */

export const DERIVED_PROPERTIES = [
];
